import React from 'react'

import PopsData from "~/data/sidebar/pops.json"
import worldMapLight from '~/images/pops-map-au-lg.svg'
import { getVisibility } from '../../../utils/helpers';

const PopsMapAu = ({ block }) => {
  const showClass = getVisibility(block.block_visibility);

  return (
    <section className={`block ${showClass} ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <div className='pops-map-wr'>
          <img src={worldMapLight} alt="World Map - bunny.net" title="World Map - bunny.net" />
          <ul className='pops-dots'>
            {PopsData.regions.map((region, index) => {
              if (region.region_class === 'oc') {
                var pops = region.pops.map((pop, index) => {
                  if (pop.name.includes(',')) {
                    pop.name_on_map = pop.name.substring( 0, pop.name.indexOf( "," ) )
                  } else {
                    pop.name_on_map = pop.name
                  }
                  if (pop.show_on_map && pop.region_map_position_top && pop.region_map_position_left) {
                    return <li key={index} className={`pop${pop.type === "volume_network" ? ' volume' : ''}`} style={{ top: `${pop.region_map_position_top}`, left: `${pop.region_map_position_left}` }}>
                      <div className="pop-dot" style={{ background: `${region.map_color}` }}></div>
                      <div className="pop-signal" style={{ background: `radial-gradient(circle,rgba(255,143,79,.14889705882352944) 0%,${region.map_color} 100%)` }}></div>
                      <div className={`label${region.dark_font_color ? ' dark' : ''}`} style={{ background: `${region.map_color}` }}>{pop.name_on_map} {pop.type === "volume_network" && <small>(Volume)</small>} {pop.planned && <small>(Planned)</small>}</div>
                    </li>
                  }
                  return ''
                })
                return <React.Fragment key={index}>{pops}</React.Fragment>
              }

              return undefined;
            })}
          </ul>
        </div>

      </div>
    </section>
  )
}

export default PopsMapAu
